import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { BsPlusCircleFill } from 'react-icons/bs';
import { CiEdit } from 'react-icons/ci';
import { RiDeleteBin5Line, RiGalleryUploadLine } from 'react-icons/ri';

interface datastructure{
 
  value:string,
  id:number,
  name:String,
}

const ContactPage = () => {
  const [selectedPostId, setSelectedPostId] = useState<string | null>(null);
  const[pagedata, setPagedata] = useState<datastructure[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  // Open modal
  const openModal = (postId: string) => {
    setSelectedPostId(postId);
    setIsModalOpen(true);
  };

  // Function to close modal and clear the post ID
  const closeModal = () => {
    setSelectedPostId(null);
    setIsModalOpen(false);
  };




  

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<datastructure[]>(
          "https://rmbbackend.rmbjaipur.com/auth/contactdata",{
            
      });

        console.log('contactdata data',response.data)
        setPagedata(response.data);
        console.log("contactdata data in a array",pagedata);
      } catch (error) {
        console.error("contactdata Not Found:", error);
      }
    };

    fetchData();
  }, []);

  console.log("contactdata data ",pagedata);
  return (
    <div>
        
    <div className='p-6 grid grid-cols-3 gap-2'>
      {pagedata.filter(item => item.name).map((item,index)=>(
        <div className='w-full rounded-2xl bg-white p-5 my-2'>
          <div className=''>
            <h1 className='mb-6 text-2xl font-bold'>Section for {item.name}</h1>
             
            

          </div>

          <div className=' flex justify-between items-center flex-row gap-3'>
        
          
         <div className='inline-block'>
         

           <p>{item.value}</p>
         </div>
          </div>
          <div className='flex w-[130px] justify-center cursor-pointer mt-3  py-2 border border-darkblue  text-darkblue items-center rounded-lg gap-2' onClick={() => openModal(item.id+"")}>
          <CiEdit/>  <h6>Edit section</h6></div>

        </div>



      ))}
      <div>

      </div>

    </div>
    {isModalOpen && (
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
        <div className="bg-white rounded-lg w-[50%] h-auto">
          {/* Close button */}
          {/* <button onClick={closeModal} className="text-red-500 font-bold absolute top-4 right-4">
            X
          </button> */}
          <Modal  postId={selectedPostId} onClose={closeModal} />
          
        </div>
      </div>
    )}
    
  </div>
  )
}

interface ModalProps {
  postId?: string | null; 
  onClose: () => void;
}

const Modal: React.FC<ModalProps> = ({ postId, onClose }) => {

  
  const [formData, setFormData] = useState({
    value: '',

  });
  const [fileName, setFileName] = useState<string | null>(null);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    if (postId) {
      const fetchPost = async () => {
        try {
          const response = await axios.get(`https://rmbbackend.rmbjaipur.com/auth/contactdata/${postId}`);
  

          const data = Array.isArray(response.data) ? response.data[0] : response.data;
 // Access the first element
  
          // Destructure from the first element of the array
          const { value } = data;
  setFormData({
    value,
  });
  
        } catch (err) {
          console.error('Error fetching post:', err);
        }
      };
      fetchPost();
    }
  }, [postId]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
  
    // Validate fields
    if (!formData.value) {
      setError('All fields are required.');
      return;
    }

  
  
    const data = new FormData();
    
    data.append('value', formData.value);
    
  
   
    console.log('Submitting form data:', {
      value: formData.value
    });
  
    try {
      if (postId) {
        await axios.put(`https://rmbbackend.rmbjaipur.com/auth/contactdata/${postId}`, { value: formData.value }, {
          headers: { 'Content-Type': 'application/json'  },
        });
        console.log('contactdata updated successfully');
      }
      onClose();
      window.location.href  = '/dashboard';
    } catch (err) {
      console.error('Error submitting contactdata:', err);
      setError('Failed to submit the contactdata. Please try again.');
    }
  };
  

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white w-1/2 p-6 rounded shadow relative">
        
        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Title */}
          <div>
            <label className="text-[#030303] font-medium"> Post title</label>
            <div className=" mt-1 w-[100%]  h-[50px]  border px-2 border-[#94A2B8] rounded-lg flex justify-center items-center mb-4 ">
            <input
              type="text"
              name="value"
              value={formData.value}
              onChange={handleChange}
             placeholder="Write your post title here..."
                            className="w-full bg-transparent placeholder-[#94A2B8] outline-none text-[14px]"
              required
            />
            </div>
          </div>


          {/* Content */}


          {/* Error Message */}
          {error && <p className="text-red-500">{error}</p>}


<div className=' flex justify-between'>

            {/*Cancel form button*/}
            <button className='mt-[22px] mx-[10px] border-[#94A2B8] border px-[20px] py-[10px] rounded-md hover:bg-[#FDBC12] hover:border-none text-[14px] font-bold'  onClick={onClose}>Cancel</button>
             {/* Submit Button */}
          <button
            type="submit"
            className='mt-[22px] bg-[#FDBC12] px-[20px] py-[10px] rounded-md hover:border-[#94A2B8] hover:border hover:bg-[#fdba1200] text-[14px]  cursor-pointer font-semibold'
            disabled={!formData.value}
          >
            Update Page
          </button>
          </div>
         




          
        </form>
      </div>
    </div>
  );
};
export default ContactPage